const HowItWorksSection = ({ onOpenDemo }) => {
    return (
        <section id="how-it-works" className="py-20 bg-blue-50">
            <div className="container mx-auto px-4">
                <div className="text-center mb-14">
                    <span className="text-blue-600 font-semibold text-sm uppercase tracking-widest">Simple Process</span>
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mt-2">
                        Up &amp; Running in Three Steps
                    </h2>
                    <p className="text-gray-500 mt-3 max-w-xl mx-auto">
                        From sign-up to your first verified delivery — in under 10 minutes.
                    </p>
                </div>

                <div className="max-w-3xl mx-auto">

                    {/* Step 1 */}
                    <div className="flex items-start gap-6 mb-2">
                        <div className="flex flex-col items-center flex-shrink-0">
                            <div className="w-14 h-14 gradient-bg rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg">
                                1
                            </div>
                            <div className="step-line mt-2"></div>
                        </div>
                        <div className="bg-white rounded-2xl p-6 shadow-sm flex-1 mb-2">
                            <div className="flex items-center gap-3 mb-2">
                                <i className="fas fa-upload text-blue-600 text-xl"></i>
                                <h3 className="text-xl font-bold text-gray-800">Upload Your Delivery Notes</h3>
                            </div>
                            <p className="text-gray-500 text-sm">
                                Drag &amp; drop one or more PDF delivery notes into the web dashboard. Name the session, assign it to a team member, and you're ready.
                            </p>
                        </div>
                    </div>

                    {/* Step 2 */}
                    <div className="flex items-start gap-6 mb-2">
                        <div className="flex flex-col items-center flex-shrink-0">
                            <div className="w-14 h-14 gradient-bg rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg">
                                2
                            </div>
                            <div className="step-line mt-2"></div>
                        </div>
                        <div className="bg-white rounded-2xl p-6 shadow-sm flex-1 mb-2">
                            <div className="flex items-center gap-3 mb-2">
                                <i className="fas fa-mobile-alt text-blue-600 text-xl"></i>
                                <h3 className="text-xl font-bold text-gray-800">Scan Parts with the Mobile App</h3>
                            </div>
                            <p className="text-gray-500 text-sm">
                                Open the StockEasy mobile app on any iOS or Android device. Point the camera at each part — barcodes or not — and let the AI do the matching.
                            </p>
                        </div>
                    </div>

                    {/* Step 3 */}
                    <div className="flex items-start gap-6">
                        <div className="flex flex-col items-center flex-shrink-0">
                            <div className="w-14 h-14 gradient-bg rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg">
                                3
                            </div>
                        </div>
                        <div className="bg-white rounded-2xl p-6 shadow-sm flex-1">
                            <div className="flex items-center gap-3 mb-2">
                                <i className="fas fa-file-alt text-blue-600 text-xl"></i>
                                <h3 className="text-xl font-bold text-gray-800">Generate &amp; Share Reports</h3>
                            </div>
                            <p className="text-gray-500 text-sm">
                                Back on the dashboard, generate a one-click PDF report. Share it with your supplier, your team, or your accounts department — instantly.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="text-center mt-12">
                    <button
                        onClick={onOpenDemo}
                        className="gradient-bg text-white px-8 py-4 rounded-xl font-bold text-base shadow-lg hover:opacity-90 transition"
                    >
                        <i className="fas fa-rocket mr-2"></i> Book a Demo &amp; Try It Yourself
                    </button>
                </div>
            </div>
        </section>
    );
};

export default HowItWorksSection;
